import { Component, Inject, NgZone, OnDestroy, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppStatus } from './appStatus.model';
import { StatutService } from './statut.service';
import { Observer } from '../../models/observer.interface';
import { NotifierService } from '../../services/notifier.service';
import { AlertService } from '../alert/alert.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AbstractSigaleComponent } from '../abstract-sigale.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { StompService } from '../../services/stomp/stomp.service';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'statut',
	templateUrl: './statut.component.html',
	styleUrls: ['./statut.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		ToastModule,
		ButtonModule
	]
})
export class StatutComponent extends AbstractSigaleComponent implements Observer, OnDestroy {

	readonly toastKey: string = 'statutComponentToastKey';

	private appStatusAbonnement: Subscription;
	appStatus: AppStatus;

	constructor(
		@Optional() private route: ActivatedRoute, private statutService: StatutService,
		private alertService: AlertService, @Optional() private notifierService: NotifierService, @Optional() private stompService: StompService,
		private ngZone: NgZone, @Optional() @Inject('$scope') private $scope: any, private messageService: MessageService) {
		super();
		if (this.route?.snapshot?.data) {
			this.appStatus = this.route?.snapshot?.data['appStatus'];
		}
	}

	ngOnInit(): void {
		super.ngOnInit();
		if (this.stompService) {
			// le stompService fonctionne sur toutes les applications, en cohabitation ou non
			this.appStatusAbonnement = this.stompService.abonnerTopic('appStatus', (appStatus: AppStatus) => {
				this.ngZone.run(() => this.onAppStatusReceived(appStatus));
			});
		}
		else if (!this.modeApplicationCohabitation) {
			this.notifierService.subscribeToTopic(this, 'appStatus');
		}
		else if (this.$scope) {
			this.$scope.$on('app:dataReceived:APP_STATUS', (event, appStatut) => this.appStatus = appStatut);
		}

		if (this.appStatus == null) {
			this.getApplicationStatus();
		}
	}

	afficherToastSuccess(): void {
		this.messageService.add({ key: this.toastKey, severity: 'success', detail: this.translateService.instant('SIGALE_ANGULAR.COMPONENTS.STATUT.OPERATION_REUSSIE') });
	}

	setApplicationDown() {
		this.statutService.setApplicationDown().subscribe(
			() => {
				this.getApplicationStatus();
				this.afficherToastSuccess();
			},
			err => this.alertService.error(err.error, this.nomAlert)
		);

	}

	setApplicationUp() {
		this.statutService.setApplicationUp().subscribe(
			() => {
				this.getApplicationStatus();
				this.afficherToastSuccess();
			},
			err => this.alertService.error(err.error, this.nomAlert)
		);
	}

	getApplicationStatus() {
		this.statutService.getApplicationStatus().subscribe(
			data => this.appStatus = data,
			err => this.alertService.error(err.error, this.nomAlert)
		);
	}

	notify(response: any): void {
		this.ngZone.run(() => {
			const status = JSON.parse(response).data;
			this.onAppStatusReceived(status);
		});
	}

	private onAppStatusReceived(appStatus: AppStatus): void {
		this.appStatus = new AppStatus(appStatus.down, Date.now());
	}

	ngOnDestroy(): void {
		if (this.stompService) {
			this.stompService.desabonner(this.appStatusAbonnement);
		}
		else if (this.notifierService) {
			this.notifierService.disconnectFromTopic('appStatus');
		}
	}

	traductionFR(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"STATUT": {
						"TITRE": "Statut de l'application",
						"STATUT": "Actuellement, l'application est au statut {{ statut }} depuis le {{ date }} à {{ heure }}.",
						"MSG_UP": "Les utilisateurs ont accès à l'application.",
						"MSG_DOWN": "Les utilisateurs non administrateurs n'ont plus accès à l'application.",
						"BTN_UP": "Désactiver l'accès à l'application",
						"BTN_DOWN": "Réactiver l'accès à l'application",
						"OPERATION_REUSSIE": "Opération réussie"
					}
				}
			}
		};
	}

	traductionIT(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"STATUT": {
						"TITRE": "Stato dell'applicazione",
						"STATUT": "Attualmente, l'applicazione é in stato {{ statut }} dal {{ date }} al {{ heure }}.",
						"MSG_UP": "Gli utenti hanno accesso all'applicazione.",
						"MSG_DOWN": "Gli utenti non amministratori non hanno più accesso all'applicazione.",
						"BTN_UP": "Disattivare l'accesso all'applicazione",
						"BTN_DOWN": "Riattivare l'accesso all'applicazione",
						"OPERATION_REUSSIE": "Operazione riuscita"
					}
				}
			}
		};
	}

}
